import { formattingNumber } from './../utils'
export const production_keys = [1, 5, 22, 10, 25, 36, 0] 
export const dev_keys = [10, 1, 5, 18, 8, 24, 0] 
export const subject_hash_color = {
    1: '#ACCB81', // 薄荷芝士派
    5:  '#EBA381', // 蛋糕英语
    22:  '#54C4A0', // 柚子鸭
    10: '#87CDEB', // 百词斩 
    25: '#9F99EB', //  夜曲编程
    36: '#B4EEB4', // 电商团队
    0: '#EBD07E' // 其他
}
// F4F8FF
const coloList = [
    '#EBA381',
    '#EBD07E',
    '#54C4A0',
    '#87CDEB',
    '#9F99EB',
    '#ACCB81',
    '#EBB482',
    '#81CE8A',
    '#EBD07E',
    '#E2B568',
    '#6CCCD7',
    '#87CDEB',
  ]
export const cash_fields_fun = () => ({
    // backgroundColor: '#F4F8FF',
    title: {
        text: '历史销售趋势',
        top: '2%',
        left: '3%',
        right: '4%',
    },
    tooltip: {
        trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        },
     },
    label: {
        show: true,
        position: 'top',
        distance: 10,
        color: "#fff",
       //  formatter: () => 'asdasd'
    },
    color:coloList,
    legend: {
        show:true,
        // selectedMode: 'single',
        // 位置
        bottom: '4%',
      //  data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎'],
    },
    grid: {
        top: '15%',
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        axisLine: {
            lineStyle: {
                opacity: 0.4
            }
        },
        minorTick: {
            show:false
        },
        minorSplitLine: {
            show:false
        },
        splitLine: {
            show: false
        },
        // data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    },
    yAxis: {
        type: 'value',
        axisLine: {
            show: false
        },
        axisLabel: {
            show: true
        },
        axisTick: {
            show: false
        },
        splitLine: {
            show: true
        },
        min: 0,
    },
});

export const cash_cicles_fun = () => ({
    cursor: 'Default',
    // backgroundColor: '#F4F8FF',
    tooltip: {
        show:false,
    },
    legend: {
        orient: 'vertical',
        show:false
    },
    series: [
        {
            animation: false,
            // name: '访问来源',
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            markPoint: {
                symbol: 'pin',
                symbolSize: 50,
                symbolOffset: [0, 0],
                label: {
                    show: true,
                    position: 'inside',
                }
            },
            labelLine: {
                length2:0,
                lineStyle: {
                    color: '#000000',
                    opacity: 0.4
                }
            },
            label: {
                position: 'outer',
                formatter: ({data}) => {
                    return `${data.name}：\n${data.value}`
                },
                alignTo: 'labelLine',
                bleedMargin: 5
            },
            data: [
                // {value: 335, name: '直接访问'},
                // {value: 310, name: '邮件营销'},
            ]
        }
    ]
});


// 总计

export const total_fun = function(data, call = formattingNumber) {
    const total_sum = data.reduce((total, item) => math.eval(`${total} + ${item}`), 0).toFixed(2)
    return {
        name: "全选",
        type:'line',
        label: {
            color: '#C0C0C0',
            show: true,
            position: 'top',
            formatter(params) {
                return total_sum ? call(params.value, 0) : ''
            }
        },
        symbol:'circle',
        symbolSize:1,
        hoverAnimation:false,
        lineStyle:{
            opacity : 0,
        },
        itemStyle:{
           color:'rgba(0,0,0,0)'
        }, 
        data
    };
}

